"use strict";
var r, o;
function e() {
  return o || (o = 1, r = Math.floor), r;
}
export {
  e as __require
};
//# sourceMappingURL=index.es311.js.map
